import "./style.scss";
import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as IconLogo } from "../../assets/icons/logo.svg";
import { ReactComponent as IconLogoDark } from "../../assets/icons/logo-dark.svg";
import { ReactComponent as IconLogoMobile } from "../../assets/icons/logo-mobile.svg";
import { ReactComponent as IconLogoMobileBlack } from "../../assets/icons/logo-mobile-black.svg";
import { ReactComponent as IconBurger } from "../../assets/icons/burger.svg";
import { ReactComponent as IconConnect } from "../../assets/icons/connect-mobile.svg";
import { ReactComponent as IconConnectBlack } from "../../assets/icons/connect-mobile-black.svg";
import { ReactComponent as IconBurgerBlack } from "../../assets/icons/burger-black.svg";
import { useMediaQuery } from "@react-hook/media-query";
import { useLocation } from "react-router-dom";
import Borders from "../../shared/borders";

const Header = ({ toggleMenu, togglePopup, isMenuOpen }) => {
  const isMobile = useMediaQuery("(max-width: 1142px)");
  const location = useLocation();

  function openMenu() {
    toggleMenu();
  }

  function openPopup() {
    togglePopup();
  }

  function chooseBackgroundClass() {
    switch (location.pathname) {
      case "/":
        return "header-main";
      default:
        return "header-light";
    }
  }

  function scrollTo(element) {
    if (location.pathname === "/") {
      if (element) {
        document.getElementById(element).scrollIntoView({
          behavior: "smooth",
        });
      } else {
        document.getElementById("App__container").scrollTo({
          top: 0,
        });
      }
    }
  }

  return (
    <div className={`header ${chooseBackgroundClass()}`}>
      <div className={`header__container`}>
        {isMobile ? (
          <div className="header__burger">
            <Link className="header__logo-container" to="/">
              {chooseBackgroundClass() === "header-main" ? (
                <IconLogoMobile
                  className={`header__logo header__logo--mobile 
                            ${isMenuOpen ? "header__transform" : ""}`}
                />
              ) : (
                <IconLogoMobileBlack
                  className={`header__logo header__logo--mobile 
                                ${isMenuOpen ? "header__transform" : ""}`}
                />
              )}
            </Link>
            {chooseBackgroundClass() === "header-main" ? (
              <div className="header__icons">
                <IconConnect
                  className="header__burger-icon"
                  onClick={openPopup}
                />
                <IconBurger
                  className="header__burger-icon"
                  onClick={openMenu}
                />
              </div>
            ) : (
              <div className="header__icons">
                <IconConnectBlack
                  className="header__burger-icon"
                  onClick={openPopup}
                />
                <IconBurgerBlack
                  className="header__burger-icon"
                  onClick={openMenu}
                />
              </div>
            )}
          </div>
        ) : null}
        {!isMobile ? (
          <Link to="/">
            {location.pathname === "/" ? (
              <IconLogo className="header__logo" />
            ) : (
              <IconLogoDark className="header__logo" />
            )}
          </Link>
        ) : null}
        {!isMobile ? (
          <nav className="header-nav">
            {/* <span className="header-nav__link">
              <Link onClick={() => scrollTo()} to="/">
                Главная
              </Link>
            </span> */}
            {/* <span className="header-nav__link">
              <Link to="/about">
                О нас
              </Link>
            </span> */}


            <div class="header-dropdown d-flex">
              <span class="header-dropdown-title">Инструменты</span>
              <div class="header-dropdown-content">
                <div class="header-dropdown-inner">
                  

                  <Link onClick={() => scrollTo("scada")} to="/#scada">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <path d="M14.6265 9.84375C14.8689 9.10636 15 8.31849 15 7.5H10.5871L8.57504 5.48795C8.39146 5.5758 8.18585 5.625 7.96875 5.625C7.1921 5.625 6.5625 4.9954 6.5625 4.21875C6.5625 3.4421 7.1921 2.8125 7.96875 2.8125C8.7454 2.8125 9.375 3.4421 9.375 4.21875C9.375 4.43585 9.3258 4.64146 9.23795 4.82504L10.9754 6.5625H14.942C14.4806 2.86283 11.3246 0 7.5 0C3.35786 0 0 3.35786 0 7.5H4.41291L6.42496 9.51205C6.60854 9.4242 6.81415 9.375 7.03125 9.375C7.8079 9.375 8.4375 10.0046 8.4375 10.7812C8.4375 11.5579 7.8079 12.1875 7.03125 12.1875C6.2546 12.1875 5.625 11.5579 5.625 10.7812C5.625 10.5642 5.6742 10.3585 5.76205 10.175L4.02459 8.4375H0.0580254C0.519367 12.1372 3.67536 15 7.5 15C10.4654 15 13.0289 13.279 14.246 10.7812H10.1183L4.82504 5.48795C4.64146 5.5758 4.43585 5.625 4.21875 5.625C3.4421 5.625 2.8125 4.9954 2.8125 4.21875C2.8125 3.4421 3.4421 2.8125 4.21875 2.8125C4.9954 2.8125 5.625 3.4421 5.625 4.21875C5.625 4.43585 5.5758 4.64146 5.48795 4.82504L10.5067 9.84375H14.6265Z" fill="#88ADD2"/>
                    </svg>
                    Единый шлюз
                  </Link>

                  <Link onClick={() => scrollTo("bp")} to="/#bp">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <path d="M11.8595 8.52132C12.0665 8.52132 12.17 8.52131 12.2539 8.56728C12.3231 8.6052 12.3875 8.6764 12.4183 8.74904C12.4557 8.83711 12.4463 8.93081 12.4275 9.11821C12.33 10.0898 11.9956 11.026 11.4498 11.8429C10.7928 12.8261 9.85909 13.5924 8.76663 14.0449C7.67417 14.4974 6.47205 14.6158 5.3123 14.3851C4.15255 14.1544 3.08725 13.585 2.25112 12.7489C1.41498 11.9127 0.84557 10.8474 0.614881 9.6877C0.384193 8.52795 0.50259 7.32583 0.955103 6.23337C1.40762 5.14091 2.17392 4.20717 3.15711 3.55022C3.97404 3.00437 4.91021 2.66998 5.88179 2.5725C6.06919 2.5537 6.16289 2.5443 6.25096 2.58166C6.3236 2.61248 6.3948 2.67689 6.43272 2.74609C6.47868 2.82999 6.47868 2.93349 6.47868 3.1405V7.92345C6.47868 8.13272 6.47869 8.23736 6.51941 8.31729C6.55524 8.3876 6.6124 8.44476 6.68271 8.48059C6.76264 8.52132 6.86728 8.52132 7.07655 8.52132H11.8595Z" fill="#88ADD2"/>
                    <path d="M8.53469 1.08449C8.53469 0.877479 8.53469 0.773972 8.58066 0.690081C8.61857 0.620876 8.68977 0.556463 8.76241 0.525642C8.85047 0.488281 8.94418 0.49768 9.13159 0.516478C10.498 0.653538 11.7826 1.2581 12.7623 2.23774C13.7419 3.21738 14.3465 4.50198 14.4835 5.86841C14.5023 6.05582 14.5117 6.14953 14.4744 6.23758C14.4435 6.31023 14.3791 6.38142 14.3099 6.41934C14.226 6.46531 14.1225 6.46531 13.9155 6.46531L9.13256 6.46531C8.92329 6.46531 8.81865 6.46531 8.73872 6.42458C8.66841 6.38876 8.61125 6.33159 8.57542 6.26128C8.53469 6.18135 8.53469 6.07671 8.53469 5.86744V1.08449Z" fill="#88ADD2"/>
                    </svg>
                    Менеджер БП
                  </Link>
                </div>
              </div>
            </div>


            <div class="header-dropdown d-flex">
              <span class="header-dropdown-title">Кейсы</span>
              <div class="header-dropdown-content">
                <div class="header-dropdown-inner">
                  <Link onClick={() => scrollTo("monitor")} to="/#monitor">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                      <path d="M3.75 2.75C3.19772 2.75 2.75 3.19772 2.75 3.75V7.75C2.75 8.30228 3.19772 8.75 3.75 8.75H11.75C12.3023 8.75 12.75 8.30228 12.75 7.75V3.75C12.75 3.19772 12.3023 2.75 11.75 2.75H3.75Z" fill="#88ADD2"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4215 3.90163e-07H4.07853C3.51726 -1.03433e-05 3.04959 -1.92858e-05 2.66773 0.0321709C2.26927 0.0657595 1.89763 0.138303 1.54763 0.322297C1.00959 0.605147 0.576465 1.05411 0.30642 1.60093C0.132097 1.95392 0.0630926 2.32853 0.0309523 2.7344C-1.55848e-05 3.12546 -8.40482e-06 3.60544 2.90092e-07 4.18664V7.42445C-8.40482e-06 8.00566 -1.55848e-05 8.48565 0.0309523 8.87671C0.0630926 9.28258 0.132097 9.6572 0.30642 10.0102C0.576465 10.557 1.00959 11.006 1.54763 11.2888C1.89763 11.4728 2.26927 11.5454 2.66773 11.5789C3.04959 11.6111 3.51725 11.6111 4.07852 11.6111H7V13H4.95C4.53579 13 4.2 13.3358 4.2 13.75C4.2 14.1642 4.53579 14.5 4.95 14.5H10.55C10.9642 14.5 11.3 14.1642 11.3 13.75C11.3 13.3358 10.9642 13 10.55 13H8.5V11.6111H11.4215C11.9828 11.6111 12.4504 11.6111 12.8323 11.5789C13.2307 11.5454 13.6024 11.4728 13.9524 11.2888C14.4904 11.006 14.9235 10.557 15.1936 10.0102C15.3679 9.6572 15.4369 9.28258 15.469 8.87671C15.5 8.48565 15.5 8.00567 15.5 7.42446V4.18665C15.5 3.60544 15.5 3.12546 15.469 2.7344C15.4369 2.32853 15.3679 1.95392 15.1936 1.60093C14.9235 1.05411 14.4904 0.605147 13.9524 0.322297C13.6024 0.138303 13.2307 0.0657595 12.8323 0.0321709C12.4504 -1.92858e-05 11.9827 -1.03433e-05 11.4215 3.90163e-07ZM12.7063 10.0842C12.3949 10.1105 11.9908 10.1111 11.39 10.1111H4.11C3.50918 10.1111 3.1051 10.1105 2.79372 10.0842C2.49182 10.0588 2.34483 10.0133 2.24561 9.9611C1.99337 9.8285 1.78398 9.61455 1.65135 9.34599C1.59679 9.23551 1.55135 9.07503 1.52627 8.7583C1.50055 8.43348 1.5 8.01317 1.5 7.39445V4.21667C1.5 3.59795 1.50055 3.17763 1.52627 2.85281C1.55135 2.53609 1.59679 2.3756 1.65135 2.26512C1.78398 1.99657 1.99337 1.78261 2.24561 1.65001C2.34483 1.59785 2.49182 1.55232 2.79372 1.52687C3.1051 1.50062 3.50918 1.5 4.11 1.5H11.39C11.9908 1.5 12.3949 1.50062 12.7063 1.52687C13.0082 1.55232 13.1552 1.59785 13.2544 1.65001C13.5066 1.78261 13.716 1.99657 13.8486 2.26512C13.9032 2.3756 13.9486 2.53609 13.9737 2.85281C13.9995 3.17763 14 3.59795 14 4.21667V7.39445C14 8.01317 13.9995 8.43348 13.9737 8.7583C13.9486 9.07503 13.9032 9.23551 13.8486 9.34599C13.716 9.61455 13.5066 9.8285 13.2544 9.9611C13.1552 10.0133 13.0082 10.0588 12.7063 10.0842Z" fill="#88ADD2"/>
                    </svg>
                    Диспетчеризация и Мониторинг
                  </Link>

                  <Link onClick={() => scrollTo("toir")} to="/#toir">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.58175 1.15951C4.5 1.31994 4.5 1.52996 4.5 1.95V2.55C4.5 2.97004 4.5 3.18006 4.58175 3.34049C4.59972 3.37577 4.62037 3.4094 4.64345 3.44113C4.6895 3.50446 4.7452 3.56019 4.8085 3.60628C4.84033 3.62947 4.87409 3.65021 4.90951 3.66826C5.06995 3.75001 5.27997 3.75001 5.7 3.75001H9.30001C9.72004 3.75001 9.93007 3.75001 10.0905 3.66826C10.2316 3.59636 10.3464 3.48162 10.4183 3.3405C10.4859 3.20782 10.4976 3.04124 10.4996 2.75H10.4996C10.5 2.68907 10.5 2.62268 10.5 2.55V1.95C10.5 1.52996 10.5 1.31994 10.4183 1.15951C10.3463 1.01839 10.2316 0.90365 10.0905 0.831745C9.93006 0.75 9.72004 0.75 9.3 0.75H5.7C5.27996 0.75 5.06994 0.75 4.90951 0.831745C4.76839 0.90365 4.65365 1.01839 4.58175 1.15951ZM3.50052 2.77131C3.37401 2.78265 3.26706 2.80003 3.16766 2.82667C2.3912 3.03472 1.78472 3.6412 1.57667 4.41766C1.5 4.70378 1.5 5.05252 1.5 5.75V12.65C1.5 13.9101 1.5 14.5402 1.74524 15.0215C1.96095 15.4448 2.30516 15.789 2.72852 16.0048C3.20982 16.25 3.83988 16.25 5.1 16.25H9.9C11.1601 16.25 11.7902 16.25 12.2715 16.0048C12.6948 15.789 13.0391 15.4448 13.2548 15.0215C13.5 14.5402 13.5 13.9101 13.5 12.65V5.75V5.74997C13.5 5.05251 13.5 4.70378 13.4233 4.41766C13.2153 3.6412 12.6088 3.03472 11.8323 2.82667C11.7329 2.80003 11.626 2.78265 11.4995 2.77131C11.4985 2.89381 11.4954 3.01477 11.4865 3.12404C11.4712 3.31094 11.4339 3.54981 11.3093 3.79449C11.1415 4.12377 10.8738 4.39149 10.5445 4.55927C10.2998 4.68394 10.0609 4.7212 9.87404 4.73647C9.70737 4.75008 9.51352 4.75005 9.32846 4.75001L9.30001 4.75001H5.70001L5.67155 4.75001C5.48649 4.75005 5.29264 4.75008 5.12598 4.73647C4.93907 4.7212 4.70021 4.68394 4.45552 4.55927C4.12624 4.39149 3.85852 4.12378 3.69075 3.79449C3.56607 3.54981 3.52882 3.31094 3.51355 3.12404C3.50462 3.01477 3.50156 2.89381 3.50052 2.77131ZM3.75 8C3.75 7.58579 4.08579 7.25 4.5 7.25H10.5C10.9142 7.25 11.25 7.58579 11.25 8C11.25 8.41421 10.9142 8.75 10.5 8.75H4.5C4.08579 8.75 3.75 8.41421 3.75 8ZM3.75 10.5C3.75 10.0858 4.08579 9.75 4.5 9.75H5.7C6.11421 9.75 6.45 10.0858 6.45 10.5C6.45 10.9142 6.11421 11.25 5.7 11.25H4.5C4.08579 11.25 3.75 10.9142 3.75 10.5ZM3.75 13C3.75 12.5858 4.08579 12.25 4.5 12.25H7.5C7.91421 12.25 8.25 12.5858 8.25 13C8.25 13.4142 7.91421 13.75 7.5 13.75H4.5C4.08579 13.75 3.75 13.4142 3.75 13Z" fill="#88ADD2"/>
</svg>
                    Техническое обслуживание и ремонт
                  </Link>

                  <Link onClick={() => scrollTo("control")} to="/#control">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
<path d="M6.5 0.5H15.5C16.0523 0.5 16.5 0.947715 16.5 1.5V10.5C16.5 11.0523 16.0523 11.5 15.5 11.5H14.5C13.9477 11.5 13.5 11.0523 13.5 10.5V4.5C13.5 3.94772 13.0523 3.5 12.5 3.5H6.5C5.94772 3.5 5.5 3.05228 5.5 2.5V1.5C5.5 0.947715 5.94772 0.5 6.5 0.5Z" fill="#88ADD2"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 5.5H11.5V16.5H0.5V5.5ZM9.22754 8.75141C9.59082 9.08662 9.59082 9.63011 9.22754 9.96533L5.6694 13.2486C5.30612 13.5838 4.71713 13.5838 4.35385 13.2486L2.77246 11.7894C2.40918 11.4541 2.40918 10.9107 2.77246 10.5754C3.13574 10.2402 3.72473 10.2402 4.08801 10.5754L5.01163 11.4277L7.91199 8.75141C8.27527 8.4162 8.86426 8.4162 9.22754 8.75141Z" fill="#88ADD2"/>
</svg>
                    Контроль регламентов
                  </Link>
                </div>
              </div>
            </div>
            {/* <span className="header-nav__link">
              <Link onClick={() => scrollTo("scada")} to="/#scada">
                Диспетчеризация
              </Link>
            </span> */}
            {/* <span className="header-nav__link">
              <Link onClick={() => scrollTo("toir")} to="/#toir">
                ТОиР
              </Link>
            </span> */}
            <span className="header-nav__link">
              <Link onClick={() => scrollTo("integration")} to="/#integration">
                Интеграция
              </Link>
            </span>
            {/* <span className="header-nav__link">
              <Link onClick={() => scrollTo("control")} to="/#control">
                Контроль
              </Link>
            </span> */}
            <span className="header-nav__link">
              <Link onClick={() => scrollTo("news")} to="/#news">
                Новости
              </Link>
            </span>
          </nav>
        ) : null}
        <div className="header__signin">
          {!isMobile ? (
            <Link
              className="header-nav__link"
              to="/about"
            >
              О нас
            </Link>
          ) : null}
          {!isMobile ? (
            <Link
              className="header-nav__link"
              onClick={() => scrollTo("footer")}
              to="/#footer"
            >
              Контакты
            </Link>
          ) : null}
          {!isMobile ? (
            <span className="header-nav__connect" onClick={openPopup}>
              Связаться с нами
            </span>
          ) : null}
        </div>
        {location.pathname !== "/" ? <Borders /> : null}
      </div>
    </div>
  );
};

export default Header;
